import { enGB } from 'date-fns/locale';
import { format } from 'date-fns';

import { getDateLocale } from 'src/helpers/date.helpers';

export const formatTrans = (date: Date, formatStr: string): string => {
	return format(date, formatStr, { locale: getDateLocale() ?? enGB });
};
